var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 71C328.1 61.6 312.9 61.6 303.6 71L135.5 239C126.1 248.4 126.1 263.6 135.5 272.9C144.9 282.2 160.1 282.3 169.4 272.9L296.4 145.9L296.4 552C296.4 565.3 307.1 576 320.4 576C333.7 576 344.4 565.3 344.4 552L344.4 145.9L471.4 272.9C480.8 282.3 496 282.3 505.3 272.9C514.6 263.5 514.7 248.3 505.3 239L337.5 71z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.8705f8c91afcaabf7895f18a3e7cb6c5.svg";
export { ForwardRef as ReactComponent };